import { InjectionToken } from '@angular/core';

export const APP_BACKEND_BUILD_VERSIONS = new InjectionToken<string>('The backend build version.', {
  providedIn: 'root',
  factory: (): string => '4.7.0.0'
});
